import RootRouter from './pages';
import { useAuth } from './hooks/auth';

import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

export default function Root() {
  const auth = useAuth();

  return (
    <>
      <RootRouter />
      <ToastContainer position="bottom-right" />
    </>
  );
}
